import type { PostJSON } from "../types/PostJSON";
import { http } from "./http";
import { isHttpError } from "./is-http-error";

export const postJSON: PostJSON = async <ResponseType>({
  payload,
  url,
}: Parameters<PostJSON>[0]) => {
  try {
    const response = await http
      .post(url, {
        json: payload,
      })
      .json<ResponseType>();

    return response;
  } catch (error) {
    await http.mainRequestErrorHandler({ error });

    if (isHttpError(error)) {
      const errorJSON = await error.response.json<Error>();

      throw new Error(errorJSON.message);
    }

    throw error;
  }
};
